import { useDispatch } from 'react-redux';
import { useOnMount } from '../../../../hooks';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { Scope } from '../../../../../shared/issuesV2';
import type { ProjectType } from '../../../../../shared/projectsV2';

/**
 * Hook which reads the projectType and dispatches an action
 * on mount to set projectType.
 *
 * If non-project scope, it sets project type to undefined.
 * @param {Scope} scope - Scope of the issue
 * @param {ProjectType} [projectType] - A projectType
 */
const useProjectType = (scope: Scope, projectType?: ProjectType) => {
  const dispatch = useDispatch();

  useOnMount(() => {
    if (scope.type === 'project') {
      dispatch(IssuesV2Store.actions.setProjectType(projectType));
    }
  });
};

export default useProjectType;
